function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import { DragSource } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";

var Bar = function (_React$Component) {
  _inherits(Bar, _React$Component);

  function Bar() {
    var _temp, _this, _ret;

    _classCallCheck(this, Bar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.setCurrentPosition = function (position) {
      _this.barNode.style.left = position + "px";

      if (_this.dragTimeout) {
        clearTimeout(_this.dragTimeout);
      }

      _this.dragTimeout = setTimeout(function () {
        _this.props.onDrag(_this.props.id, position);

        _this.dragTimeout = null;
      }, 100);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Bar.prototype.componentDidMount = function componentDidMount() {
    var connectDragPreview = this.props.connectDragPreview;

    if (connectDragPreview) {
      connectDragPreview(getEmptyImage());
    }
  };

  Bar.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        connectDragSource = _props.connectDragSource,
        id = _props.id,
        start = _props.start,
        duration = _props.duration,
        text = _props.text,
        src = _props.src,
        style = _props.style,
        onClick = _props.onClick;
    return connectDragSource(React.createElement("i", {
      ref: function ref(_ref) {
        return _this2.barNode = _ref;
      },
      "data-custom": true,
      "data-start": start,
      "data-duration": duration,
      "data-id": id,
      "data-text": text,
      "data-src": src,
      key: id,
      style: style,
      onClick: onClick
    }));
  };

  return Bar;
}(React.Component);

Bar.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  start: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  text: PropTypes.string,
  src: PropTypes.string,
  onBeginDrag: PropTypes.func.isRequired,
  onDrag: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired
} : {};
var spec = {
  beginDrag: function beginDrag(props, monitor, component) {
    props.onBeginDrag();
    return {
      id: props.id,
      component: component
    };
  }
};

function collect(connect) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview()
  };
}

export default DragSource("GraphicAssetTrackBar", spec, collect)(Bar);